const checkStatusUser = (status) => {
    if (status === "Unauthorized") {
        return true;
    } else {
        return false;
    }
};
export default checkStatusUser;
